import * as React from "react";
import { useFieldArray } from "react-hook-form";
import useTranslations from "../../hooks/useTranslations";
import QuestionOptionsConfigurator from "./QuestionOptionsConfigurator";

interface TemplateQuestionOptionsConfigurationProps {
  selectedLocale: string;
  control;
  register;
}

export const TemplateQuestionOptionsConfiguration: React.FC<TemplateQuestionOptionsConfigurationProps> = ({
  selectedLocale,
  control,
  register,
}) => {
  const t = useTranslations();
  const { fields } = useFieldArray({
    name: "questionOptionsConfigurationsAttributes",
    control,
    keyName: "_rhfid",
  });

  return (
    <div className="flex" id="templateQuestionOptionsConfiguration">
      <div className="w-full">
        {fields.map((field, fieldIndex) => (
          <div
            key={field.id}
            className={field.locale !== selectedLocale ? "hidden" : ""}
          >
            <QuestionOptionsConfigurator
              register={register}
              control={control}
              field={field}
              fieldIndex={fieldIndex}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
